import React, { Fragment, useState, useEffect, useCallback } from 'react';
import Header from '../../components/header/Header';
import { Link } from "react-router-dom";
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import psImg from '../../images/portfolio/portfolio_item_image_1.jpg'
import pImg2 from '../../images/portfolio/portfolio_item_image_2.webp'
import pImg3 from '../../images/portfolio/portfolio_item_image_3.webp'

import p1 from '../../images/portfolio/td01.jpg'
import p2 from '../../images/portfolio/td02.jpg'
import p3 from '../../images/portfolio/td03.jpg'
import p4 from '../../images/portfolio/td04.jpg'
import p5 from '../../images/portfolio/td05.jpg'
import p6 from '../../images/portfolio/td06.jpg'
import p7 from '../../images/portfolio/td07.jpg'
import p8 from '../../images/portfolio/td08.jpg'


import icon from '../../images/icons/icon_check_3.svg'

// ─── Inline Styles ────────────────────────────────────────────────────────────

const galleryStyles = `
  /* ── Gallery Section ── */
  .destiny-gallery-section {
    padding: 80px 0 40px;
    background: #ffffff;
  }
  .destiny-section-label {
    
  }
  .destiny-section-title {
	font-size: 40px;
    line-height: 55px;
    margin-bottom: 20px;
  }
  .destiny-section-title span {
    
  }
  .destiny-section-subtitle {
    
  }

  /* ── Filter Tabs ── */
  .gallery-filter-tabs {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 40px;
  }
  .filter-tab {
    padding: 8px 22px;
    border: 1px solid #333;
    background: transparent;
    color: #888;
    font-size: 13px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    cursor: pointer;
    border-radius: 2px;
    transition: all 0.25s ease;
    font-family: inherit;
  }
  .filter-tab:hover,
  .filter-tab.active {
    border-color: var(--bs-dark);
    color: var(--bs-dark);
  }

  /* ── Image Grid ── */
  .gallery-grid {
    columns: 4;
    column-gap: 12px;
    margin-bottom: 12px;
  }
  @media (max-width: 900px) { .gallery-grid { columns: 2; } }
  @media (max-width: 576px) { .gallery-grid { columns: 1; } }

  .gallery-item {
    break-inside: avoid;
    margin-bottom: 12px;
    position: relative;
    overflow: hidden;
    border-radius: 3px;
    cursor: pointer;
    background: #111;
  }
  .gallery-item img {
    width: 100%;
    display: block;
    transition: transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  .gallery-item:hover img {
    transform: scale(1.06);
  }
  .gallery-item-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.75) 0%, transparent 55%);
    opacity: 0;
    transition: opacity 0.3s ease;
    display: flex;
    align-items: flex-end;
    padding: 20px;
  }
  .gallery-item:hover .gallery-item-overlay {
    opacity: 1;
  }
  .gallery-item-overlay-content {
    transform: translateY(8px);
    transition: transform 0.3s ease;
  }
  .gallery-item:hover .gallery-item-overlay-content {
    transform: translateY(0);
  }
  .gallery-item-tag {
    font-size: 10px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #c8a96e;
    display: block;
    margin-bottom: 4px;
  }
  .gallery-item-caption {
    font-size: 14px;
    color: #fff;
    font-weight: 500;
  }
  .gallery-zoom-btn {
    position: absolute;
    top: 14px;
    right: 14px;
    width: 36px;
    height: 36px;
    background: rgba(255,0,0,0.9);
    border: none;
    border-radius: 2px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0;
    transform: scale(0.8);
    transition: all 0.25s ease;
    font-size: 16px;
  }
  .gallery-item:hover .gallery-zoom-btn {
    opacity: 1;
    transform: scale(1);
  }

  /* ── Lightbox ── */
  .lightbox-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.95);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.2s ease;
  }
  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  .lightbox-inner {
    position: relative;
    max-width: 90vw;
    max-height: 90vh;
    display: flex;
    align-items: center;
  }
  .lightbox-inner img {
    max-width: 85vw;
    max-height: 85vh;
    object-fit: contain;
    border-radius: 3px;
    box-shadow: 0 40px 120px rgba(0,0,0,0.8);
  }
  .lightbox-close {
    position: fixed;
    top: 24px;
    right: 28px;
    background: rgba(200,169,110,0.15);
    border: 1px solid rgba(200,169,110,0.4);
    color: #c8a96e;
    width: 44px;
    height: 44px;
    border-radius: 2px;
    font-size: 22px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    z-index: 10000;
  }
  .lightbox-close:hover { background: rgba(200,169,110,0.3); }
  .lightbox-nav {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(200,169,110,0.15);
    border: 1px solid rgba(200,169,110,0.4);
    color: #c8a96e;
    width: 48px;
    height: 48px;
    border-radius: 2px;
    font-size: 22px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    z-index: 10000;
  }
  .lightbox-nav:hover { background: rgba(200,169,110,0.3); }
  .lightbox-prev { left: 20px; }
  .lightbox-next { right: 20px; }
  .lightbox-counter {
    position: fixed;
    bottom: 28px;
    left: 50%;
    transform: translateX(-50%);
    color: #888;
    font-size: 13px;
    letter-spacing: 2px;
    z-index: 10000;
  }

  /* ── Video Section ── */
  .destiny-video-section {
    padding: 60px 0 80px;
    background: #e3f0ff;
    border-top: 1px solid #e3f0ff;
  }
  .video-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  @media (max-width: 768px) { .video-grid { grid-template-columns: 1fr; } }

  .video-card {
    position: relative;
    border-radius: 3px;
    overflow: hidden;
    background: #111;
    cursor: pointer;
    group: true;
  }
  .video-card-featured {
    grid-column: 1 / -1;
  }
  .video-thumbnail {
    width: 100%;
    aspect-ratio: 16/9;
    object-fit: cover;
    display: block;
    transition: transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  .video-card:hover .video-thumbnail {
    transform: scale(1.04);
  }
  .video-card-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.2) 50%, rgba(0,0,0,0.6) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s;
  }
  .video-card:hover .video-card-overlay {
    background: linear-gradient(135deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.5) 100%);
  }
  .play-btn {
    width: 68px;
    height: 68px;
    border-radius: 50%;
    background: rgba(255,0,0,0.9);
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 8px 32px rgba(265,0,0,0.4);
  }
  .video-card-featured .play-btn {
    width: 84px;
    height: 84px;
  }
  .video-card:hover .play-btn {
    transform: scale(1.1);
    background: #ff0000;
	box-shadow: 0 12px 48px rgb(255 0 0 / 63%);
  }
  .play-btn svg {
    width: 26px;
    height: 26px;
    fill: #0a0a0a;
    margin-left: 4px;
  }
  .video-card-featured .play-btn svg { width: 32px; height: 32px; }
  .video-card-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px 24px;
    background: linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 100%);
  }
  .video-card-tag {
    font-size: 10px;
    letter-spacing: 2.5px;
    text-transform: uppercase;
    color: #c8a96e;
    display: block;
    margin-bottom: 6px;
  }
  .video-card-title {
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    margin: 0 0 4px;
  }
  .video-card-featured .video-card-title { font-size: 22px; }
  .video-card-duration {
    font-size: 12px;
    color: #aaa;
  }

  /* ── Video Modal ── */
  .video-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.97);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.2s ease;
  }
  .video-modal-inner {
    position: relative;
    width: min(900px, 92vw);
  }
  .video-modal-inner iframe,
  .video-modal-inner video {
    width: 100%;
    aspect-ratio: 16/9;
    border: none;
    border-radius: 3px;
    display: block;
  }
  .video-modal-close {
    position: absolute;
    top: -52px;
    right: 0;
    background: rgba(200,169,110,0.15);
    border: 1px solid rgba(200,169,110,0.4);
    color: #c8a96e;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }
  .video-modal-close:hover { background: rgba(200,169,110,0.3); }

  /* ── Stats Row ── */
  .gallery-stats {
    
  }
  .gallery-stat {  }
  .gallery-stat-number {
    
  }
  .gallery-stat-label {
    
  }
`;

// ─── Mock Data ────────────────────────────────────────────────────────────────

// Using placeholder images for demo — replace src values with your actual imports
const galleryImages = [
  { id: 1, src: p1, tag: '', caption: '', category: '' },
  { id: 2, src: p2, tag: '', caption: '', category: '' },
  { id: 3, src: p3, tag: '', caption: '', category: '' },
  { id: 4, src: p4, tag: '', caption: '', category: '' },
  { id: 5, src: p5, tag: '', caption: '', category: '' },
  { id: 6, src: p6, tag: '', caption: '', category: '' },
  { id: 7, src: p7, tag: '', caption: '', category: '' },
  { id: 8, src: p8, tag: '', caption: '', category: '' },  
 ];

const videoItems = [
  {
    id: 1,
    featured: true,
    thumbnail: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=1200&q=80',
    tag: 'Behind The Scenes',
    title: 'The Destiny — Full Campaign BTS',
    duration: '4:32',
    youtubeId: 'dQw4w9WgXcQ', // replace with actual YouTube ID
  },
  {
    id: 2,
    thumbnail: 'https://images.unsplash.com/photo-1536240478700-b869ad10e2d8?w=800&q=80',
    tag: 'Showreel',
    title: 'Editorial Highlights',
    duration: '1:48',
    youtubeId: 'dQw4w9WgXcQ',
  },
  {
    id: 3,
    thumbnail: 'https://images.unsplash.com/photo-1574267432553-4b4628081c31?w=800&q=80',
    tag: 'Process',
    title: 'Studio Setup & Lighting',
    duration: '2:15',
    youtubeId: 'dQw4w9WgXcQ',
  },
];

//const FILTER_TABS = ['all', 'editorial', 'studio', 'outdoor'];
const FILTER_TABS = ['all'];

// ─── Sub-components ───────────────────────────────────────────────────────────

const ImageGallery = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const filtered = activeFilter === 'all'
    ? galleryImages
    : galleryImages.filter(img => img.category === activeFilter);

  const openLightbox = (idx) => setLightboxIndex(idx);
  const closeLightbox = () => setLightboxIndex(null);
  const goNext = useCallback(() => setLightboxIndex(i => (i + 1) % filtered.length), [filtered.length]);
  const goPrev = useCallback(() => setLightboxIndex(i => (i - 1 + filtered.length) % filtered.length), [filtered.length]);

  useEffect(() => {
    if (lightboxIndex === null) return;
    const handler = (e) => {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') goNext();
      if (e.key === 'ArrowLeft') goPrev();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [lightboxIndex, goNext, goPrev]);

  return (
    <>
      {/* Filter */}
      <div className="gallery-filter-tabs">
        {FILTER_TABS.map(tab => (
          <button
            key={tab}
            className={`filter-tab${activeFilter === tab ? ' active' : ''}`}
            onClick={() => setActiveFilter(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Grid */}
      <div className="gallery-grid">
        {filtered.map((img, idx) => (
          <div className="gallery-item" key={img.id} onClick={() => openLightbox(idx)}>
            <img src={img.src} alt={img.caption} loading="lazy" />
            <div className="gallery-item-overlay">
              <div className="gallery-item-overlay-content">
                <span className="gallery-item-tag">{img.tag}</span>
                <span className="gallery-item-caption">{img.caption}</span>
              </div>
            </div>
            <button className="gallery-zoom-btn" aria-label="Zoom">⊕</button>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-inner" onClick={e => e.stopPropagation()}>
            <img
              src={filtered[lightboxIndex].src}
              alt={filtered[lightboxIndex].caption}
            />
          </div>
          <button className="lightbox-close" onClick={closeLightbox}>✕</button>
          <button className="lightbox-nav lightbox-prev" onClick={(e) => { e.stopPropagation(); goPrev(); }}>‹</button>
          <button className="lightbox-nav lightbox-next" onClick={(e) => { e.stopPropagation(); goNext(); }}>›</button>
          <div className="lightbox-counter">{lightboxIndex + 1} / {filtered.length}</div>
        </div>
      )}
    </>
  );
};

const VideoGallery = () => {
  const [activeVideo, setActiveVideo] = useState(null);

  const openVideo = (video) => setActiveVideo(video);
  const closeVideo = () => setActiveVideo(null);

  useEffect(() => {
    if (!activeVideo) return;
    const handler = (e) => { if (e.key === 'Escape') closeVideo(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [activeVideo]);

  return (
    <>
      <div className="video-grid">
        {videoItems.map(video => (
          <div
            key={video.id}
            className={`video-card${video.featured ? ' video-card-featured' : ''}`}
            onClick={() => openVideo(video)}
          >
            <img className="video-thumbnail" src={video.thumbnail} alt={video.title} loading="lazy" />
            <div className="video-card-overlay">
              <button className="play-btn" aria-label="Play video">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </button>
            </div>
            <div className="video-card-info">
              <span className="video-card-tag">{video.tag}</span>
              <h4 className="video-card-title">{video.title}</h4>
              <span className="video-card-duration">▶ {video.duration}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Video Modal */}
      {activeVideo && (
        <div className="video-modal-overlay" onClick={closeVideo}>
          <div className="video-modal-inner" onClick={e => e.stopPropagation()}>
            <button className="video-modal-close" onClick={closeVideo}>✕</button>
            <iframe
              src={`https://www.youtube.com/embed/${activeVideo.youtubeId}?autoplay=1`}
              title={activeVideo.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </>
  );
};

// ─── Main Page Component ──────────────────────────────────────────────────────

const ClickHandler = () => { window.scrollTo(10, 0); };

const Project01Photography = () => {
  return (
    <Fragment>
      {/* Inject styles */}
      <style>{galleryStyles}</style>

      <Header />
      <main className="page_content about-page">
        <PageTitle pageTitle="Photography" pagesub={'Details 😃'} pageTop={'Portfolio'} />

        {/* ── Existing Portfolio Details ── */}
        <section className="portfolio_details_section section_space bg-light">
          <div className="container">

            <div className="details_item_image">
              <img src={psImg} alt="Photography Portfolio" />
            </div>

            <h2 className="details_item_title">Photography – The Destiny</h2>
            <p>
              A vibrant portfolio shoot for The Destiny, capturing emotion, elegance and visual storytelling
              at its finest. Our photography team worked closely with the client to understand their brand
              identity and translate it into compelling imagery that resonates with their target audience.
            </p>
            <p className="mb-0">
              From concept development to post-production retouching, every frame was crafted with
              precision and creative intent — delivering a portfolio that truly reflects the essence of
              The Destiny brand.
            </p>

            <hr />

            <ul className="portfolio_details_info_list icon_list unordered_list justify-content-lg-between mb-5">
              <li>
                <span className="icon_list_text">
                  <strong className="text-dark text-uppercase">Services:</strong> Photography
                </span>
              </li>
              <li>
                <span className="icon_list_text">
                  <strong className="text-dark text-uppercase">Client:</strong> The Destiny
                </span>
              </li>
              <li>
                <span className="icon_list_text">
                  <strong className="text-dark text-uppercase">Category:</strong> Portfolio Shoot
                </span>
              </li>
              <li>
                <span className="icon_list_text">
                  <strong className="text-dark text-uppercase">Completed Date:</strong> 15-03-2024
                </span>
              </li>
            </ul>

            <h3 className="details_item_info_title pt-4">Project Requirement</h3>
            <p>
              The client required a full portfolio shoot covering multiple looks, locations and moods
              to represent the brand across digital and print media. The brief called for high-end
              editorial quality with a consistent visual language throughout.
            </p>

          </div>
        </section>

        {/* ── Image Gallery Section ── */}
        <section className="destiny-gallery-section">
          <div className="container">
            <h2 className="destiny-section-title">Image <span>Gallery</span></h2>
            <p className="destiny-section-subtitle">
              A curated collection of photographs that reflects our creativity, style, and dedication to excellence.
            </p>

            <ImageGallery />
          </div>
        </section>

        {/* ── Video Gallery Section ── */}
        <section className="destiny-video-section">
          <div className="container">
            <h2 className="destiny-section-title">Video <span>Showcase</span></h2>
            <p className="destiny-section-subtitle">
              Behind-the-scenes footage, showreels and process videos from the shoot
            </p>

            <VideoGallery />
          </div>
        </section>

        <CtaSection />
      </main>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default Project01Photography;
